import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVideo,
  faStar,
  faClipboard,
  faCamera,
  faPen,
  faGlobe,
  faHandshake,
  faTrophy,
  faDollarSign,
} from "@fortawesome/free-solid-svg-icons";

export const ROLE_OPTIONS = [
  { label: "Filmmaker",       value: "Filmmaker",       icon: faVideo },
  { label: "Actor",           value: "Actor",           icon: faStar },
  { label: "Producer",        value: "Producer",        icon: faClipboard },
  { label: "Cinematographer", value: "Cinematographer", icon: faCamera },
  { label: "Writer",          value: "Writer",          icon: faPen },
  { label: "Distributor",     value: "Distributor",     icon: faGlobe },
  { label: "Sales Agent",     value: "Sales Agent",     icon: faHandshake },
  { label: "Film Festival",   value: "Film Festival",   icon: faTrophy },
  { label: "Investor",        value: "Investor",        icon: faDollarSign },
];

function RoleChoice({ role, setRole, onNext }) {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isLight = theme === 'light';

  const handleSelect = (option) => {
    setRole({ label: option.label, value: option.value, icon: option.icon });
  };

  return (
    <div className="tw-flex tw-flex-col">
      <div className="tw-mb-6">
        <h2 className={`tw-text-2xl tw-font-bold ${isLight ? 'tw-text-[#1E0039]' : 'tw-text-white'}`}>
          {t("Who are you in the industry?")}
        </h2>
        <p className={`tw-mt-1 tw-text-sm ${isLight ? 'tw-text-gray-500' : 'tw-text-gray-400'}`}>
          {t("Select your role to get started")}
        </p>
      </div>

      <div className="tw-grid tw-grid-cols-3 tw-gap-3 tw-mb-6">
        {ROLE_OPTIONS.map((option) => {
          const isSelected = role.value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => handleSelect(option)}
              className={`tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2.5 tw-rounded-xl tw-border tw-px-2 tw-py-4 tw-text-center tw-transition-all tw-cursor-pointer tw-bg-transparent
                ${isSelected
                  ? "tw-border-[#FF43A7] tw-bg-[#FF43A7]/15 tw-shadow-[0_0_16px_rgba(255,67,167,0.25)]"
                  : isLight
                    ? "tw-border-gray-200 tw-bg-white hover:tw-border-[#FF43A7]/40 hover:tw-bg-[#FF43A7]/8"
                    : "tw-border-white/10 tw-bg-white/5 hover:tw-border-[#FF43A7]/40 hover:tw-bg-[#FF43A7]/8"
                }`}
            >
              <FontAwesomeIcon
                icon={option.icon}
                className={`tw-text-lg ${isSelected ? "tw-text-[#FF43A7]" : (isLight ? "tw-text-gray-500" : "tw-text-gray-400")}`}
              />
              <span className={`tw-text-xs tw-font-medium tw-leading-tight ${
                isSelected ? (isLight ? "tw-text-[#1E0039]" : "tw-text-white") : (isLight ? "tw-text-gray-500" : "tw-text-gray-400")
              }`}>
                {t(option.label)}
              </span>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        onClick={onNext}
        disabled={!role.value}
        className="tw-w-full tw-cursor-pointer tw-rounded-full tw-border-0 tw-bg-[#FF43A7] tw-py-3 tw-text-base tw-font-semibold tw-text-white tw-shadow-[0_0_20px_rgba(255,67,167,0.3)] tw-transition-all hover:tw-bg-[#FF43A7]/80 disabled:tw-cursor-not-allowed disabled:tw-opacity-40"
      >
        {t("Continue")}
      </button>
    </div>
  );
}

export default RoleChoice;
